<template>
  <v-alert :class="$style.blackListAlert">
    <div :class="$style.blacklistWrapper">
      <div :class="$style.blackListContent">
        <div :class="$style.blackListIconBlock">
          <img src="@/assets/icons/blackListPerson.svg" alt="" />
        </div>
        <div :class="$style.blackListInfoBlock">
          <h6 :class="$style.blacklistTitle">
            <slot name="title"></slot>
          </h6>
          <p :class="$style.blacklistText">
            <slot name="text"></slot>
          </p>
        </div>
      </div>
      <v-btn
        color="primary"
        :class="$style.sendMessageBtn"
        :large="$mq !== 'sm'"
        width="17rem"
        @click="$router.push('/personal/faq')"
      >
        Написать письмо
      </v-btn>
    </div>
  </v-alert>
</template>

<script>
export default {}
</script>

<style lang="scss" module>
.blackListAlert {
  background-color: $regularBlack !important;
  margin: 0 0 10px 0;
}
.blackListContent {
  display: flex;
}
.blacklistTitle, .blacklistText {
  color: #fff;
}
.blacklistTitle {
  font-weight: 700;
  font-size: toRem(21);
  @media (max-width: $mobileWidth) {
    font-size: toRem(17);
  }
}
.blacklistText {
  margin: 5px 0 0 0;
  font-size: toRem(15);
}
.blacklistWrapper {
  padding: 10px 20px;
  display: flex;
  justify-content: space-between;
  @media (max-width: $mobileWidth) {
    flex-direction: column;
  }
}
.blackListIconBlock {
  margin: 5px 16px 0 0;
}

.reviewTitle {
  font-size: toRem(21);
  line-height: 26px;
  font-weight: 700;
}
.blackListInfoBlock {
  display: flex;
  flex-direction: column;
  justify-content: center;
  @media (max-width: $mobileWidth) {
    width: 80%;
  }
}
.sendMessageBtn{
  margin: 2px 0 0 20px;
  font-weight: 400;
  @media (max-width: $mobileWidth) {
    margin: 2px 0 0 40px;
  }
}
</style>
